import { Component, OnInit, Input } from '@angular/core';
import { Constants } from '../../../shared/models/constants';

@Component({
  selector: 'app-pageCreation',
  templateUrl: './pageCreation.component.html',
  styleUrls: ['./pageCreation.component.css']
})
export class PageCreationComponent implements OnInit {
  @Input() data: any;

  public pagesTabActive: boolean = false;
  public servicesOptions = [];
  public pageOptions = [];

  constructor() {
    var enrichmentOptions = Constants.getEnrichmentOptions();
    var keys = Object.keys(enrichmentOptions);
    keys.forEach(key => {
      if (enrichmentOptions[key].isService)
        this.servicesOptions.push(enrichmentOptions[key]);
      else
        this.pageOptions.push(enrichmentOptions[key]);
    });
  }

  ngOnInit() {
    this.pagesTabActive = true;
    this.pageOptions = this.pageOptions.filter(function (obj) {
      return (obj.type !== "duplicateAsImage" && obj.type !== "duplicateAsPage");
    });


  }

  onPagesTabClick(): void {
    this.pagesTabActive = true;
    document.getElementsByClassName("globalpopup")[0]["style"].height = "231px";
  }
  onServicesTabClick(): void {
    this.pagesTabActive = false;
    document.getElementsByClassName("globalpopup")[0]["style"].height = "290px";
  }
  onpageClick(option, evt) {
    evt.stopPropagation();
    if (option.type == 'internet' || option.type == 'pageFromBook' || option.type == 'youtube' || option.type == 'googleDocs' || option.type == 'spreadSheet' || option.type == 'presentation')
      this.data.popupProps.showPopup = false;
    this.data.popupProps.curComp.callBackAddPage(option);

  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/pageCreation/pageCreation.component.ts